<template>
  <div class="modal-window alert ab001">
    <header class="modal-header">
      <div class="tit">{{ modalInfo.title }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>
    
    <div class="modal-content">
      <div class="info-txt small"  v-html="modalInfo.contents"></div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty2" @click="$emit('close')">{{ $i18nUtil.trans("button.cancel","취소") }}</button> 
      <button type="button" class="btn_ty1" @click="onSubmit">{{ modalInfo.btnName }}</button>
    </footer>
  </div>
</template>
<script>

export default {
  props:{
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return { 
      error: true,
    };
  },
  methods: {
    onSubmit() {
      let obj = this;
      let modalName = obj.modalInfo.name;

      if(modalName == 'deleteFileAll') {
        obj.$emit("deleteFile", obj.modalInfo);
        obj.$emit("close");
      } else if(modalName == 'deleteFileBoard') {
        obj.$emit("deleteFile", obj.modalInfo);
        obj.$emit("close");
      } else if( modalName == 'deleteFolder'){  
         let param = {
            item:obj.modalInfo.item,
            idx:obj.modalInfo.idx
          }
          let parentCategory =obj.modalInfo.parentCategory;
          obj.$emit("delete-category",param,parentCategory); 
          obj.$emit("close");
      }else if(modalName == "[AB033]"){ 
        obj.$emit("delete_category",obj.modalInfo.categoryInfo);  
        obj.$emit("close");
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ConfirmModal.vue